import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
	buttonContainer: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-end',
	},
}));
